export const LEGACY_CONTACT_CATEGORY = "Probetraining" as const;

export const contactCategories = ["Allgemeines", "Beratungsgespräch", "Mitgliedschaft"] as const;

export type ContactCategory = (typeof contactCategories)[number];

const contactCategorySet = new Set<string>(contactCategories);

export function parseContactCategory(value?: string | null): ContactCategory | null {
  const normalizedValue = value?.trim();

  if (!normalizedValue) {
    return null;
  }

  if (normalizedValue === LEGACY_CONTACT_CATEGORY) {
    return "Beratungsgespräch";
  }

  return contactCategorySet.has(normalizedValue) ? (normalizedValue as ContactCategory) : null;
}

export function normalizeContactCategory(value?: string | null): ContactCategory {
  return parseContactCategory(value) ?? "Allgemeines";
}

export function getContactCategoryLabel(value?: string | null) {
  const normalizedValue = value?.trim();

  if (!normalizedValue) {
    return "Allgemeines";
  }

  return normalizedValue === LEGACY_CONTACT_CATEGORY ? "Beratungsgespräch" : normalizedValue;
}